// Core
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 40px;
`;

export const LabelsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  margin: 16px 0;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin: 0 0 16px 0;
`;

export const EnableItemsContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;
